import { render, staticRenderFns } from "./positionPoint.vue?vue&type=template&id=f86a0b16&"
import script from "./positionPoint.vue?vue&type=script&lang=js&"
export * from "./positionPoint.vue?vue&type=script&lang=js&"
import style0 from "./positionPoint.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports